var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.sleepColumnQuality },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "sleepColumnQuality",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Quality", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.sleepColumnWakeups },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "sleepColumnWakeups",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Wakeups", {})) + "\n\t")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }